import bemCssModules from 'bem-css-modules';
import { observer } from 'mobx-react-lite';
import type { VFC } from 'react';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAsyncEffect } from 'use-async-effect';

import CategoryPageModuleCss from './CategoryPage.module.css';
import { BreadcrumbsWithData } from '~/components/BreadCrumbs/BreadcrumbsWithData';
import { Loading } from '~/components/Loading/Loading';
import { SubcategoryItem } from '~/components/SubcategoryItem/SubcategoryItem';
import { LocalizationItem } from '~/constants';
import type { SiteMapItem } from '~/models/siteMap';
import { useCategoryStore } from '~/stores';

const block = bemCssModules(CategoryPageModuleCss);

export const CategoryPage: VFC = observer(() => {
  const [isLoaded, setIsLoaded] = useState(false);

  const {
    categoryCollection,
    subcategoryCollection,
    loadCategoryCollection,
    loadSubcategoryCollection,
    getCurrentCategoryInstance,
  } = useCategoryStore();

  const { categoryName } = useParams<{ categoryName: string }>();

  useAsyncEffect(async () => {
    if (!categoryCollection.length) {
      await loadCategoryCollection();
    }
    await loadSubcategoryCollection(categoryName);
    setIsLoaded(true);
  }, []);

  if (!isLoaded) {
    return <Loading />;
  }

  const siteMapItemCollection = [];

  const siteMapItemPathDefault: SiteMapItem = {
    Path: '/',
    Title: LocalizationItem.SupportCenter,
  };
  const siteMapItemPathCategory: SiteMapItem = {
    Path: `/${categoryName}`,
    Title: getCurrentCategoryInstance?.Name ?? '',
  };

  siteMapItemCollection.push(siteMapItemPathDefault, siteMapItemPathCategory);

  return (
    <>
      <BreadcrumbsWithData siteMapItemCollection={siteMapItemCollection} />
      <div className={block()}>
        <h1 className={block('title')}> {getCurrentCategoryInstance?.Name}</h1>
        {subcategoryCollection.map((item) => (
          <SubcategoryItem
            key={item.Title}
            {...item}
          />
        ))}
      </div>
    </>
  );
});
